/* eslint-disable no-console */
import {InfoCircleOutlined} from '@ant-design/icons';
import {Col, Form, Input, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useContext, useEffect, useState} from 'react';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {API_ENDPOINT_JSON} from '../../config';
import {CommonErrors} from '../../constants/Common';
import FilteredUnit from '../../constants/FilteredUnit';
import InformativeText from '../../constants/InformativeText';
import SelectedCountryContext from '../../pages/configurator/orgFacility/Constants/SelectedCountryContext';
import {sortYearOptions} from '../../pages/orgManager/Utils/InfraStructureProfile/constant/sorYear';
import NumberInput from '../../shared/NumberInput';
import yearFilterArray from '../../shared/YearFilterArray';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import useUserStore from '../../store/userStore/userStore';
import {hasUserRole, UserRole} from '../../utils/commonFunctions';
import {FirstCap} from '../../utils/FormUtils/FirstCap';
import RegEx from '../../utils/FormUtils/RegEx';
import PhoneNumberInput from '../CustomInputs/PhoneNumberInput/PhoneNumberInput';

import {BusKey, BusLabel} from './Constants/IP/businessKeyLabel';
import {
  documentUrlKeyLabel,
  facilityKeyLabel,
  yearKeyLabel
} from './Constants/IP/commonKeyLabel';
import AttachedDocumentUpload from './Utils/AttachedDocumentUpload';
import {filterSelectOptions} from './Utils/commonFunctions';

const BusinessForm: React.FC<{
  data?: any;
  currentStep?: number;
  defaultDisplayStep?: boolean;
  formSelectedCountry: string | undefined;
  setFormSelectedCountry: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
}> = ({
  currentStep,
  formSelectedCountry,
  setFormSelectedCountry,
  defaultDisplayStep = false
}) => {
  const isCompanyUserOrAdmin =
    hasUserRole(UserRole.Company_Admin) || hasUserRole(UserRole.Company_user);
  const modeOfTransport = useJSONStore((state) => state.modeOfTransportTrav);
  const frequencyOfTravel = useJSONStore((state) => state.frequency);
  const {efdbData, facilityId, selectedYear, selectedCountry} = useContext(
    SelectedCountryContext
  );
  const userDetails = useUserStore.getState().userDetails;

  const [facilityEfdb, setFacilityEfdb] = useState<any>();

  const {getFieldValue, setFields} = useFormInstance();

  const busInfo = InformativeText?.IP?.travel?.bus;

  const facilityDetails = useCompanyStore.getState().facilityDetails;

  const [facilityOpt, setFacilityOpt] = useState<any[]>([]);

  useEffect(() => {
    setFacilityOpt(
      facilityDetails?.[
        getFieldValue(yearKeyLabel.key) ?? selectedYear ?? ''
      ]?.filter((item: any) => {
        return !item.isLeased;
      }) ?? []
    );
    setFacilityEfdb(
      efdbData?.[getFieldValue(yearKeyLabel.key) ?? selectedYear ?? '']?.find(
        (i: any) => {
          return (
            i.facilityId === (getFieldValue(facilityKeyLabel.key) ?? facilityId)
          );
        }
      )
    );
  }, []);

  useEffect(() => {
    setFormSelectedCountry(
      facilityOpt?.find((item: any) => {
        return (
          item?._id === (getFieldValue(facilityKeyLabel.key) ?? facilityId)
        );
      })?.country
    );
  }, [facilityOpt]);

  const [yearOptions, setYearOptions] = useState<any[]>([]);

  useEffect(() => {
    setYearOptions(
      yearFilterArray(
        facilityDetails,
        !isCompanyUserOrAdmin ? userDetails?.facility : undefined,
        false
      )
    );
  }, []);

  useEffect(() => {
    setFacilityOpt(
      facilityDetails?.[
        getFieldValue(yearKeyLabel.key) ?? selectedYear ?? ''
      ]?.filter((item: any) => {
        return !item.isLeased;
      }) ?? []
    );
  }, []);

  return (
    <>
      {(currentStep === 0 || defaultDisplayStep) && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              initialValue={selectedYear}
              hidden={defaultDisplayStep}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={sortYearOptions(yearOptions)}
                suffixIcon={<YearCalender />}
                disabled={getFieldValue('_id') !== undefined}
                onChange={(e) => {
                  setFacilityOpt(
                    facilityDetails?.[e]?.filter((item: any) => {
                      return !item.isLeased;
                    }) ?? []
                  );
                  setFacilityEfdb(() => {
                    return efdbData?.[e]?.find((i: any) => {
                      return (
                        i?.facilityId === getFieldValue(facilityKeyLabel.key)
                      );
                    });
                  });
                  if (getFieldValue(facilityKeyLabel.key)) {
                    setFields([
                      {
                        name: facilityKeyLabel.key,
                        value: undefined,
                        errors: ['Please select facility again']
                      }
                    ]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          {isCompanyUserOrAdmin && (
            <>
              <Col className="gutter-row">
                <Form.Item
                  name={facilityKeyLabel.key}
                  label={facilityKeyLabel.label}
                  labelCol={{span: 24}}
                  hidden={defaultDisplayStep}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(facilityKeyLabel.label)
                    }
                  ]}
                  initialValue={facilityId}
                >
                  <Select
                    placeholder={facilityKeyLabel.label}
                    options={
                      facilityOpt?.map((item: any) => {
                        return {label: item.name, value: item._id};
                      }) ?? []
                    }
                    disabled={getFieldValue('_id') !== undefined}
                    onChange={(e) => {
                      setFacilityEfdb(() => {
                        return efdbData?.[
                          getFieldValue(yearKeyLabel.key)
                        ]?.find((i: any) => {
                          return i?.facilityId === e;
                        });
                      });
                      if (getFieldValue(BusKey.MODE)) {
                        setFields([
                          {
                            name: BusKey.MODE,
                            errors: [CommonErrors.selectAgain],
                            value: undefined
                          }
                        ]);
                      }
                      setFormSelectedCountry(
                        facilityDetails?.[
                          getFieldValue(yearKeyLabel.key) ?? ''
                        ]?.find((item: any) => {
                          return item._id === e;
                        })?.country
                      );
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </>
      )}
      {(currentStep === 1 || defaultDisplayStep) && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={BusKey.FIRST_NAME}
              label={BusLabel.FIRST_NAME}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(BusLabel.FIRST_NAME)
                },
                {
                  max: 100,
                  message: `${BusLabel.FIRST_NAME} Should not be more than 100 Characters`
                },
                {
                  min: 2,
                  message: `${BusLabel.FIRST_NAME} Should be more than 1 Characters`
                },
                {
                  pattern: RegEx.names,
                  message:
                    'No special characters , Empty spaces or Numbers are Allowed'
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = FirstCap(target.value);
                }}
                placeholder={`Enter ${BusLabel.FIRST_NAME}`}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={BusKey.LAST_NAME}
              label={BusLabel.LAST_NAME}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(BusLabel.LAST_NAME)
                },
                {
                  max: 100,
                  message: `${BusLabel.LAST_NAME} Should not be more than 100 Characters`
                },
                // {
                //   min: 2,
                //   message: `${BusLabel.LAST_NAME} Should be more than 1 Characters`
                // },
                {
                  pattern: RegEx.names,
                  message:
                    'No special characters , Empty spaces or Numbers are Allowed'
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = FirstCap(target.value);
                }}
                placeholder={`Enter ${BusLabel.LAST_NAME}`}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row">
            <Form.Item
              name={BusKey.EMAIL}
              label={BusLabel.EMAIL}
              labelCol={{span: 24}}
              rules={[
                // {
                //   required: true,
                //   message: CommonErrors.mandatory(BusLabel.EMAIL)
                // },
                {
                  min: 5,
                  message: `${BusLabel.EMAIL} Should be more than 4 Characters`
                },
                {
                  max: 320,
                  message: `${BusLabel.EMAIL} Should not be more than 320 Characters`
                },
                {
                  pattern: RegEx.email,
                  message: CommonErrors.validField(BusLabel.EMAIL)
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input placeholder={`Enter ${BusLabel.EMAIL}`} />
            </Form.Item>
          </Col>

          <Col className="gutter-row">
            <Form.Item
              name={BusKey.MOBILE}
              label={BusLabel.MOBILE}
              labelCol={{span: 24}}
              rules={[
                // {
                //   required: true,
                //   message: CommonErrors.mandatory(BusLabel.MOBILE)
                // },
                {
                  // eslint-disable-next-line @typescript-eslint/promise-function-async
                  validator(_, value) {
                    if (/^\+\d{4,}$/.test(value)) {
                      if (RegEx.mobile.test(value)) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          new Error(CommonErrors.validField(BusLabel.MOBILE))
                        );
                      }
                    } else {
                      return Promise.resolve();
                    }
                  }
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <PhoneNumberInput />
            </Form.Item>
          </Col>

          <Col className="gutter-row">
            <Form.Item
              name={BusKey.FREQUENCY_OF_TRAVEL}
              label={BusLabel.FREQUENCY_OF_TRAVEL}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(BusLabel.FREQUENCY_OF_TRAVEL)
                }
              ]}
            >
              <Select
                showSearch
                className="select"
                placeholder={`Choose ${BusLabel.FREQUENCY_OF_TRAVEL}`}
                options={frequencyOfTravel}
                filterOption={filterSelectOptions}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={BusKey.NO_OF_FREQUENCY}
              label={BusLabel.NO_OF_FREQUENCY}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(BusLabel.NO_OF_FREQUENCY)
                },
                {
                  pattern: RegEx.nonDecimal,
                  message: CommonErrors.nonDecimalNonNegative
                }
              ]}
              validateFirst={true}
              hasFeedback
              labelCol={{span: 24}}
            >
              <NumberInput placeholder={`Enter ${BusLabel.NO_OF_FREQUENCY}`} />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={BusKey.MODE}
              label={BusLabel.MODE}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(BusLabel.MODE)
                }
              ]}
            >
              <Select
                showSearch
                className="select"
                placeholder={`Choose ${BusLabel.MODE}`}
                options={modeOfTransport.filter((item) => {
                  return item?.dbName === facilityEfdb?.scope3;
                })}
                filterOption={filterSelectOptions}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row">
            <Form.Item dependencies={[BusKey.FROM, BusKey.TO]} noStyle>
              {({getFieldValue}) => (
                <Form.Item
                  name={BusKey.DISTANCE_TRAVELLED}
                  label={BusLabel.DISTANCE_TRAVELLED}
                  rules={[
                    {
                      required:
                        !getFieldValue(BusKey.FROM) &&
                        !getFieldValue(BusKey.TO),
                      message: CommonErrors.mandatory(
                        BusLabel.DISTANCE_TRAVELLED
                      )
                    },
                    {
                      pattern: RegEx.nonDecimal,
                      message: CommonErrors.nonDecimalNonNegative
                    }
                  ]}
                  labelCol={{span: 24}}
                  initialValue={null}
                  tooltip={{
                    icon: <InfoCircleOutlined />,
                    title: busInfo?.distanceTravelled
                  }}
                >
                  <NumberInput
                    addonAfter={
                      FilteredUnit(formSelectedCountry ?? selectedCountry)
                        .distance
                    }
                    placeholder={`Enter ${BusLabel.DISTANCE_TRAVELLED}`}

                    // disabled={homeAdd || offAdd}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>

          <Col className="gutter-row">
            <Form.Item
              dependencies={[BusKey.DISTANCE_TRAVELLED, BusKey.TO]}
              noStyle
            >
              {({getFieldValue}) => (
                <Form.Item
                  name={BusKey.FROM}
                  rules={[
                    {
                      required:
                        !getFieldValue(BusKey.DISTANCE_TRAVELLED) ||
                        getFieldValue(BusKey.TO),
                      message: CommonErrors.mandatory(BusLabel.FROM)
                    }
                  ]}
                  label={BusLabel.FROM}
                  labelCol={{span: 24}}
                  initialValue={''}
                >
                  <Input
                    className="input"
                    placeholder={`Enter ${BusLabel.FROM}`}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.value = FirstCap(target.value);
                    }}
                    // disabled={distanceTrav}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>

          <Col className="gutter-row">
            <Form.Item
              dependencies={[BusKey.DISTANCE_TRAVELLED, BusKey.FROM]}
              noStyle
            >
              {({getFieldValue}) => (
                <Form.Item
                  name={BusKey.TO}
                  rules={[
                    {
                      required:
                        !getFieldValue(BusKey.DISTANCE_TRAVELLED) ||
                        getFieldValue(BusKey.FROM),
                      message: CommonErrors.mandatory(BusLabel.TO)
                    }
                  ]}
                  label={BusLabel.TO}
                  labelCol={{span: 24}}
                  initialValue={''}
                >
                  <Input
                    className="input"
                    placeholder={`Enter ${BusLabel.TO}`}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.value = FirstCap(target.value);
                    }}
                    // disabled={distanceTrav}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={BusKey.COST}
              label={BusLabel.COST}
              labelCol={{span: 24}}
              rules={[
                {
                  pattern: RegEx.nonDecimal,
                  message: CommonErrors.nonDecimalNonNegative
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <NumberInput
                addonAfter={
                  FilteredUnit(formSelectedCountry ?? selectedCountry).currency
                }
                placeholder={`Enter ${BusLabel.COST}`}
                isFormatted={true}
              />
            </Form.Item>
          </Col>
          {!defaultDisplayStep && (
            <Col className="gutter-row">
              <Form.Item
                name={documentUrlKeyLabel.key}
                label={documentUrlKeyLabel.label}
                labelCol={{span: 24}}
              >
                <AttachedDocumentUpload
                  uploadEndpoint={
                    API_ENDPOINT_JSON.businessTravelUploadAttachedDocument
                  }
                />
              </Form.Item>
            </Col>
          )}
        </>
      )}
    </>
  );
};

export default BusinessForm;
